import { FC } from 'react';

type Props = {
	className?: string;
};

const SearchNotFoundIconDuotone: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			fill='none'>
			<path
				opacity='0.4'
				d='M9.29988 3.34999C12.5859 3.34999 15.2498 6.01385 15.2498 9.29988C15.2498 12.5859 12.5859 15.2498 9.29988 15.2498C6.01385 15.2498 3.34999 12.5859 3.34999 9.29988C3.34999 6.01385 6.01385 3.34999 9.29988 3.34999Z'
				fill='#2B2B2B'
				stroke='#2B2B2B'
				strokeWidth='0.699986'
			/>
			<path
				d='M13.8516 13.8496L17.0015 16.9995'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15.5998 9.29988C15.5998 5.82055 12.7792 3 9.29988 3C5.82055 3 3 5.82055 3 9.29988C3 12.7792 5.82055 15.5998 9.29988 15.5998C12.7792 15.5998 15.5998 12.7792 15.5998 9.29988Z'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinejoin='round'
			/>
			<path
				d='M7.19922 11.3996L11.3991 7.19971M7.19922 7.19971L11.3991 11.3996'
				stroke='#2B2B2B'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default SearchNotFoundIconDuotone;
